import { render, staticRenderFns } from "./RiskFlaggedAnswersPart.vue?vue&type=template&id=35047ef0&scoped=true"
import script from "./RiskFlaggedAnswersPart.vue?vue&type=script&lang=js"
export * from "./RiskFlaggedAnswersPart.vue?vue&type=script&lang=js"
import style0 from "./RiskFlaggedAnswersPart.vue?vue&type=style&index=0&id=35047ef0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35047ef0",
  null
  
)

export default component.exports